import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ModelAnswerSourceCodeModuleName } from '@/store/modules/modules'

export class ModelAnswerSourceCodeViewModel {
  private store = useStore()

  modelAnswerSourceCodeList: ComputedRef<{ [judgeId: number]: string }> = computed(
    () => this.store.getters[`${ModelAnswerSourceCodeModuleName}/modelAnswerSourceCodeList`]
  )
  loading: ComputedRef<boolean> = computed(() => this.store.getters[`${ModelAnswerSourceCodeModuleName}/loading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${ModelAnswerSourceCodeModuleName}/error`])

  setModelAnswerSourceCodeList(list: { [judgeId: number]: string }): void {
    this.store.commit(`${ModelAnswerSourceCodeModuleName}/setModelAnswerSourceCodeList`, { list })
  }

  isAlreadySourceCodeRequested(judgeId: number): boolean {
    return judgeId in this.modelAnswerSourceCodeList.value
  }

  async fetchModelAnswerSourceCodeList(judgeId: number): Promise<void> {
    await this.store.dispatch(`${ModelAnswerSourceCodeModuleName}/fetchModelAnswerSourceCodeList`, {
      judgeId
    })
  }
}
